import React, { useEffect } from 'react';
import Link from '@mui/material/Link';
import { useLingui } from '@lingui/react';

const POLICY_ID = '50045299';

export const PrivacyPolicyLink: React.FC = () => {
  const { i18n } = useLingui();

  useEffect(() => {
    if (!document.querySelector('script[src="https://cdn.iubenda.com/iubenda.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.iubenda.com/iubenda.js';
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  return React.createElement(
    Link,
    {
      href: `https://www.iubenda.com/privacy-policy/${POLICY_ID}`,
      className: 'iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe',
      title: i18n._('Privacy Policy'),
      target: '_blank',
      rel: 'noreferrer',
      variant: 'body2',
      underline: 'always',
      color: 'text.secondary',
      sx: { textAlign: 'center' },
    },
    i18n._('Privacy Policy'),
  );
};

export const CookiePolicyLink: React.FC = () => {
  const { i18n } = useLingui();

  return React.createElement(
    Link,
    {
      href: `https://www.iubenda.com/privacy-policy/${POLICY_ID}/cookie-policy`,
      className: 'iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe',
      title: i18n._('Cookie Policy'),
      target: '_blank',
      rel: 'noreferrer',
      variant: 'body2',
      underline: 'always',
      color: 'text.secondary',
      sx: { textAlign: 'center' },
    },
    i18n._('Cookie Policy'),
  );
};

export const TermsAndConditionsLink: React.FC = () => {
  const { i18n } = useLingui();

  return React.createElement(
    Link,
    {
      href: `https://www.iubenda.com/termini-e-condizioni/${POLICY_ID}`,
      className: 'iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe',
      title: i18n._('Terms and Conditions'),
      target: '_blank',
      rel: 'noreferrer',
      variant: 'body2',
      underline: 'always',
      color: 'text.secondary',
      sx: { textAlign: 'center' },
    },
    i18n._('Terms and Conditions'),
  );
};
